import { USDC } from "../../models/UsdcValue";
import Button from "../miscellaneous/Button";
import { ButtonTheme } from "../miscellaneous/ButtonTheme";
import Dialog from "./components/Dialog";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  ThreadsIcon,
  ThreadsShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

export interface ShareDialogProps {
  onClose: () => void;
  earnings: USDC;
}

export default function ShareDialog(props: ShareDialogProps) {
  const url = window.location.origin;
  let message = `🎉 I just won ${props.earnings.pretty} ETH on BitMillions! Play the crypto lottery where win or lose, you're making a difference! 💸🌍\n\n👉 ${url}\n\n`;
  const hashtags = ["BitMillions", "Crypto", "WinOrLose", "Ethereum"];
  for (let i = 0; i < hashtags.length; i++) {
    message += `#${hashtags[i]} `;
  }
  return (
    <Dialog onClose={props.onClose}>
      <div className="flex flex-col items-center ~px-10/8">
        <span className="flex text-center ~text-lg/xxl ~leading-5/6 font-barlowc font-bold text-silver ~mb-6/8">
          SHARE YOUR EARNINGS
        </span>
        <div className="flex flex-wrap gap-4  justify-center">
          <TwitterShareButton url={url} title={message}>
            <XIcon size={48} round />
          </TwitterShareButton>
          <TelegramShareButton url={url} title={message}>
            <TelegramIcon size={48} round />
          </TelegramShareButton>
          <WhatsappShareButton url={url} title={message}>
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>
          <FacebookShareButton url={url} title={message}>
            <FacebookIcon size={48} round />
          </FacebookShareButton>
          <ThreadsShareButton url={url} title={message}>
            <ThreadsIcon size={48} round />
          </ThreadsShareButton>
          <LinkedinShareButton url={url} title={message}>
            <LinkedinIcon size={48} round />
          </LinkedinShareButton>
        </div>
        <span className="flex text-center ~text-sm/base ~leading-5/6 font-barlowc font-bold text-silver ~mt-6/8 ~w-80/96">
          {message}
        </span>
        <div className="~mt-6/8">
          <Button
            text={"CLOSE"}
            enabled={true}
            loading={false}
            theme={ButtonTheme.PersianPink}
            onClick={props.onClose}
          ></Button>
        </div>
      </div>
    </Dialog>
  );
}
